export default __webpack_public_path__ + "static/ORANGE_GLOW_BG-50cdc8253cf859cbe443447bf76f6c9e.png";